import React from "react";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <div className="footer">
      <footer>
        <Link to="/" className="link">
          <div className="site-name">
            <span style={{ color: "darkgreen" }}>S</span>
            <span style={{ color: "orange" }}>T</span>
            <span style={{ color: "dodgerblue" }}>A</span>
            <span style={{ color: "green" }}>C</span>
            <span style={{ color: "red" }}>K</span>
            <span>ify</span>
          </div>
        </Link>
      </footer>
    </div>
  );
}

export default Footer;
